'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClickOutside = function (_Component) {
  _inherits(ClickOutside, _Component);

  function ClickOutside() {
    var _temp, _this, _ret;

    _classCallCheck(this, ClickOutside);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handle = function (e) {
      var onClickOutside = _this.props.onClickOutside;

      var el = _this.container;
      if (!el.contains(e.target)) onClickOutside(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ClickOutside.prototype.componentDidMount = function componentDidMount() {
    document.addEventListener('click', this.handle, true);
  };

  ClickOutside.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('click', this.handle, true);
  };

  ClickOutside.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        onClickOutside = _props.onClickOutside,
        props = _objectWithoutProperties(_props, ['children', 'onClickOutside']);

    return _react2.default.createElement(
      'div',
      _extends({}, props, { ref: function ref(_ref) {
          return _this2.container = _ref;
        } }),
      children
    );
  };

  return ClickOutside;
}(_react.Component);

exports.default = ClickOutside;
ClickOutside.propTypes = process.env.NODE_ENV !== "production" ? {
  onClickOutside: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.any
} : {};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/OutsideClick/index.js
// module id = 574
// module chunks = 14